import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { ANIMATION_FUNCTION, IconButton } from "@similarweb/ui-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const transition = `all 200ms ${ANIMATION_FUNCTION}`;
const expandTransition = `all 600ms ${ANIMATION_FUNCTION}`;

export const ExpandButton = styled(IconButton)<{ isExpanded: boolean }>`
    transition: ${expandTransition};
    transform: ${({ isExpanded }) => (isExpanded ? "rotate(90deg)" : "rotate(0deg)")};
`;

export const LetsGoButton = styled(IconButton)<{ isExpanded: boolean; isInSidebar?: boolean }>`
    transition: ${transition};
    opacity: ${({ isExpanded, isInSidebar = false }) => (isExpanded || isInSidebar ? 1 : 0)};

    &&& svg path {
        fill: ${colorsPalettes.blue[400]};
    }
`;

export const StyledOnboardingHubCard = styled.div<{ isExpanded: boolean; isDone: boolean; isInSidebar?: boolean }>`
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;

    border-radius: 6px;
    border: 1px solid
        ${({ isInSidebar = false }) => (isInSidebar ? colorsPalettes.blue[100] : colorsPalettes.carbon[50])};
    background: ${({ isInSidebar = false }) => (isInSidebar ? colorsPalettes.blue[50] : colorsPalettes.carbon[0])};
    box-shadow: 0 0 0 0 rgba(14, 30, 62, 0.08);

    transition: ${transition};

    &:hover {
        background: ${({ isExpanded, isDone }) =>
            isExpanded || isDone ? colorsPalettes.carbon[0] : colorsPalettes.blue[50]};
        box-shadow: ${({ isExpanded, isDone }) => (isExpanded || isDone ? "0 0 0 0" : "0 3px 6px 0")}
            rgba(14, 30, 62, 0.08);

        ${LetsGoButton} {
            opacity: ${({ isDone }) => (isDone ? 0 : 1)};
        }
    }
`;

export const StyledOnboardingHubCardHeader = styled(FlexRow)<{ isInSidebar?: boolean }>`
    width: 100%;
    box-sizing: border-box;
    padding: ${({ isInSidebar = false }) => (isInSidebar ? "4px 6px" : "3px 11px 3px 3px")};
    align-items: center;
    gap: ${({ isInSidebar = false }) => (isInSidebar ? "6px" : "4px")};

    .doneMarkIcon {
        padding: 8px;
    }
`;

export const StyledOnboardingHubCardBodyWrapper = styled(FlexRow)<{ isExpanded: boolean }>`
    width: 100%;
    box-sizing: border-box;
    display: grid;
    overflow: hidden;
    grid-template-rows: ${({ isExpanded }) => `${isExpanded ? "1fr" : "0fr"}`};
    transition: ${expandTransition};

    & > div {
        overflow: hidden;
    }
`;

export const StyledOnboardingHubCardBody = styled(FlexRow)`
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 8px 27px 15px 27px;
`;

export const StyledOnboardingHubCardTitle = styled.span<{ isDone: boolean; isInSidebar?: boolean }>`
    ${({ isInSidebar = false, isDone }) =>
        isInSidebar
            ? setFontVariant("dataTable2", colorsPalettes.black[0])
            : setFontVariant(isDone ? "input2" : "input2Bold", colorsPalettes.carbon[400])};
    font-style: normal;
    flex-grow: 1;
`;

export const StyledOnboardingHubOrderSpan = styled.span`
    ${setFontVariant("caption2", colorsPalettes.blue[400])};
    border-radius: 50%;
    background-color: ${colorsPalettes.blue[100]};
    border: none;
    padding: 1px 6px;
`;
